import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { ContactItemComponent } from './contact-item.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  imports: [ 
    CommonModule, 
    FormsModule, 
    IonicModule, 
    TranslateModule, 
    NgxSkeletonLoaderModule,
  ],
  declarations: [ContactItemComponent],
  exports: [ContactItemComponent, TranslateModule]
})
export class ContactItemComponentModule {}
